import type { LocalSettingsState } from '@ps/web-core-store';
import produce from 'immer';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

export function usePromptTourActions() {
  const { localSettings } = useDispatch<Dispatch>();
  const { userSeenPrompt } = useSelector(select.localSettings.get);

  const updateUserTour = (flow: string) => {
    localSettings.set({
      userSeenPrompt: produce(
        userSeenPrompt || {},
        (draft: Partial<LocalSettingsState['userSeenPrompt']> = {}) => {
          if (flow === 'cashier') {
            draft.firstDeposit = true;
            draft.firstWithdraw = true;
            draft.cashier = true;
          } else {
            // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
            draft[flow] = true;
          }
        }
      )
    });
  };

  return updateUserTour;
}
